import { useState } from "react";
import Image from "next/image";

export function ImageLoader({
  src,
  alt,
  width = 100,
  height = 100,
  className = "",
}: {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
}) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <div className={`relative bg-white ${className}`}>
      {loading && !error && (
        <div className="absolute inset-0 bg-gray-200 rounded-sm z-10 animate-pulse" />
      )}

      {error ? (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-sm text-gray-400">
          <span className="text-xs">Failed to load</span>
        </div>
      ) : (
        <Image
          src={src}
          alt={alt}
          width={width}
          height={height}
          onLoad={handleLoad}
          onError={handleError}
          className={`w-full h-full object-contain rounded-sm transition-opacity duration-200 ${
            loading ? "opacity-0" : "opacity-100"
          }`}
        />
      )}
    </div>
  );
}
